import { ExperimentSpec } from '../../commonv2/states/globalStates';

export enum ExperimentName {
    CHANGE_TOP_PAGE_KEY_VISUAL = 'change_top_page_key_visual',
}

export const RUNNING_EXPERIMENTS: ExperimentSpec[] = [
    {
        name: ExperimentName.CHANGE_TOP_PAGE_KEY_VISUAL,
        forceOverrideKey: 'change_top_page_key_visual',
        optimizeExperimentId: 'jfHwvhMHQtSrIFI7GmI_Ng',
    },
];
